module.exports = __webpack_public_path__ + "media/images/lb/975-a0bd64d6fae3fd6dfff73592077ac8ff.svg";